import { useTranslation } from 'react-i18next'
import { DutiesDisclaimer } from '@components/DutiesDisclaimer/DutiesDisclaimer'
import { IsGiftOption } from '@components/IsGiftOption/IsGiftOption'
import { SansText } from '@velasca/ui/sans-text'
import { $settings } from '@velasca/utils/globals'
import { Content, LineDescription } from './Summary.styles'
import type { SummaryProps } from './Summary.types'

export const Summary = ({
  cartTotalPrice,
  setIsGiftOrder,
}: SummaryProps): JSX.Element => {
  const { t } = useTranslation('global')

  return (
    <Content>
      <LineDescription>
        <SansText>{t('cart_label_shipping')}</SansText>
        <SansText fontStyle="italic">{t('shipping_fees')}</SansText>
      </LineDescription>

      <LineDescription>
        <SansText uppercase fontWeight="500" size="md">
          {t('cart_total_label')}
        </SansText>
        <SansText
          size="md"
          dangerouslySetInnerHTML={{
            __html: cartTotalPrice,
          }}
        />
      </LineDescription>

      <IsGiftOption setIsGiftOrder={setIsGiftOrder} />
      {$settings.show_duties_text && <DutiesDisclaimer />}
    </Content>
  )
}
